import { defineMessages } from 'react-intl';
import { v4 as uuid } from 'uuid';

const messages = defineMessages({
  channelSubtitle: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  channelTitle: { id: 'Title', defaultMessage: 'Title' },
  complaint: { id: 'Complaint', defaultMessage: 'Complaint' },
  compliment: { id: 'Compliment', defaultMessage: 'Compliment' },
  icon: { id: 'Icon', defaultMessage: 'Icon' },
  iconDescriptionPart1: {
    id: 'Icon description part 1',
    defaultMessage: 'You can find the available icons at',
  },
  iconDescriptionPart2: {
    id: 'Icon description part 2',
    defaultMessage:
      '. For example, you can use "fa-regular fa-calendar" for an Regular Calendar icon. You can browse available icons at Font Awesome Icons Free. Copy the class name and paste it here.',
  },
  serviceChannels: {
    id: 'Service channels',
    defaultMessage: 'Service channels',
  },
  subtitle: { id: 'Area subtitle', defaultMessage: 'Area subtitle' },
  solicitation: { id: 'Solicitation', defaultMessage: 'Solicitation' },
  suggestion: { id: 'Suggestion', defaultMessage: 'Suggestion' },
  title: { id: 'Area title', defaultMessage: 'Area title' },
  titleDescription: {
    id: 'titleDescription',
    defaultMessage:
      'For the Service Channels area to be displayed, it is necessary to fill in at least one of the Title or Subtitle fields.',
  },
  url: { id: 'URL', defaultMessage: 'URL' },
  channels: { id: 'Channels', defaultMessage: 'Channels' },
  channel: { id: 'Channel', defaultMessage: 'Channel' },
  defaultSubtitle: {
    id: 'defaultSubtitle',
    defaultMessage:
      'You can make more demonstrations on the following channels.',
  },
});

export const serviceChannelsSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.serviceChannels),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.serviceChannels),
        fields: ['title', 'subtitle', 'channels'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        description: intl.formatMessage(messages.titleDescription),
        default: intl.formatMessage(messages.serviceChannels),
      },
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
        default: intl.formatMessage(messages.defaultSubtitle),
      },
      channels: {
        title: intl.formatMessage(messages.channels),
        widget: 'object_list',
        schema: {
          title: intl.formatMessage(messages.channel),
          fieldsets: [
            {
              id: 'default',
              title: intl.formatMessage(messages.channel),
              fields: ['title', 'subtitle', 'icon', 'url'],
            },
          ],
          properties: {
            title: {
              title: intl.formatMessage(messages.channelTitle),
            },
            subtitle: {
              title: intl.formatMessage(messages.channelSubtitle),
            },
            icon: {
              title: intl.formatMessage(messages.icon),
              description: (
                <>
                  {intl.formatMessage(messages.iconDescriptionPart1)}{' '}
                  <a
                    href="https://fontawesome.com/search?ic=free"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Font Awesome Icons Free
                  </a>
                  {intl.formatMessage(messages.iconDescriptionPart2)}
                </>
              ),
            },
            url: {
              title: intl.formatMessage(messages.url),
              widget: 'url',
            },
          },
          required: ['title', 'icon', 'url'],
        },
        placeholderItemField: 'title',
        default: [
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.complaint),
            icon: 'fas fa-bullhorn',
          },
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.solicitation),
            icon: 'fa fa-comments',
          },
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.suggestion),
            icon: 'fas fa-comment',
          },
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.compliment),
            icon: 'fa fa-thumbs-up',
          },
        ],
      },
    },
    required: [],
  };
};
